// //开发环境
// export const environment = {
//   production: false,

//   //API标准格式形如：http://xxx.xxx.xxx.xxx/  （注意最后斜杠）

//   //#region  seeker基础平台微服务api地址配置区域
//   seekerWebAPI: "http://192.168.10.96:8000/sw-basic/",          //基础平台微服务api

//   fileWebAPI: "http://192.168.10.96:8000/sw-file/",           //文件处理微服务api

//   activitiWebAPI: "http://192.168.10.96:8000/sw-activiti/",     //工作流微服务api

//   scheduleWebApi: "http://192.168.10.96:8000/sw-scheduler/",   //任务调度微服务api

//   ruleWebApi: "http://192.168.10.96:8000/sw-rule/",            //规则引擎微服务api

//   webSoketApi: "ws://192.168.10.96:8000:8041/",                   //消息队列

//   outWebAPI: "http://192.168.10.96:8000:8074/",                      //out第三方服务api(如与钉钉同步)

//   smsWebAPI: "http://192.168.10.96:8000:8021/",                      //短信验证码发送服务api

//   esWebAPI: "http://192.168.10.96:8000/sw-es/",                 //es全文检索服务

//   saasWebAPI: "http://192.168.10.96:8000/sw-saas/",             //saas租户管理服务api

//   staticFileUrl: "http://192.168.10.96:8081/fileUpload/",      //静态资源文件web站点

//   onlineOfficeWebAPI: "http://192.168.10.210:9999/",            //文件在线编辑服务api

//   iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",            //openseadragon大图预览插件

//   uploadDirectory: "7588b9f22b0c11eba02c7020840bjwys",                                 //文件上传目录（以项目分文件夹存储）

//   sendCodeUrl: "http://192.168.10.89:8021/",                   //发送短信验证码接口地址

//   //#endregion

//   //#region 智慧博物馆业务产品领域微服务api地址配置区域
//   cmsWebAPI: "http://192.168.10.96:8000/sw-cms/",               //门户内容服务api

//   damWebAPI: "http://192.168.10.96:8000/sw-dam/",               //观众系统服务api

//   trmWebAPI: "http://192.168.10.96:8000/sw-trm/",               //票务预约服务api

//   actWebAPI: "http://192.168.10.96:8000/sw-act/",               //活动预约服务api

//   volWebAPI: "http://192.168.10.96:8000/sw-vve/",               //志愿者微服务api

//   vipWebAPI: "http://192.168.10.96:8000/sw-vve/",               //会员微服务api

//   expWebAPI: "http://192.168.10.96:8000/sw-vve/",               //讲解员微服务api

//   wecWebAPI: 'http://192.168.10.96:8000/sw-cms/',               //微信后台微服务api

//   apfWebAPI: "http://192.168.10.96:8000/sw-apf/",               //观众客流分析微服务api

//   ckfWebAPI: "http://192.168.10.96:8000/sw-ckf-cloud-bjkg/",               //藏品系统微服务api

//   drmWebAPI: "http://192.168.10.96:8000/sw-drm/",               //数字资源微服务api

//   amsWebAPI: "http://192.168.10.96:8000/sw-oms/",               //固定资产微服务api

//   dssWebAPI: "http://192.168.10.96:8000/sw-dss/",               //决策支持微服务api

//   dpsWebAPI: "http://192.168.10.96:8000/sw-dps/",               //研发内部使用API
//   //#endregion

//   //#region  其他业务产品领域微服务api地址配置区域
//   pcrWebAPI: "http://192.168.10.96:8000/sw-pcr-zy/",               //预防性保护系统API

//   cirWebAPI: "",

//   apmWebAPI: "http://192.168.10.96:8000/sw-apm-bj/",
//   famWebAPI: "http://192.168.10.96:8000/sw-fam-bj/",

//   famPanoPrefix: "http://192.168.10.75:8002/",                   //田野考古全景访问地址

//   caAPI: "http://192.168.10.75:11001/",                          // CA验证API

//   caWebsocketApi: "ws://192.168.10.75:11001/",                   // CA二维码登陆websocket地址

//   apoWebAPI: "",

//   proWebAPI: "",

//   webSocketPcrUrl: "",

//   kgsWebAPI: "http://192.168.10.97:8095/",                     //知识图谱微服务api

//   mapWebAPI: "",                                               //知识地图微服务api

//   rmsWebAPI: "http://192.168.10.66:9990/sw-rms",               //数据资源管理微服务api

//   sesWebAPI: "http://192.168.10.66:9990/sw-ses",               //知识图谱检索微服务api

//   qasWebAPI: "http://192.168.10.66:9990/sw-qas",               //问答管理微服务api

//   omsWebAPI: "http://192.168.10.96:8000/sw-oms/",               //办公管理微服务api
//   anbWebAPI: "http://192.168.10.96:8000/sw-anb-bj-hds/",
//   aamWebAPI: 'http://192.168.10.96:8000/sw-aam/',
//   sicWebAPI: "http://192.168.10.96:8000/sw-sic-bj/",               //考古工地安全微服务api
//   rdpWebAPI: "http://192.168.10.96:8000/sw-rdp-bj-wyj/",               //考古工地安全微服务api

//   //#endregion

//   //#region 项目基本属性配置区域

//   guidVideoFilePath: "7588b9f22b0c11eba02c7020840bjwys/operateVideo/",   //指引视频地址

//   dataDashboardUrl: "http://192.168.10.13:8324/",               //数据大屏地址

//   encryptedPassword: false,                                     //是否加密密码

//   multiTenancy: false,                                           //是否开启多租户管理模式

//   systemCode: 'WYS_BEIJING',                                               //系统编号（默认不填，multiTenancy为false必填）

//   isVcode: false,                                               //登录界面是否有验证码,默认需要验证码,值为true

//   isSliderCode: false,                                 //登录界面是否有滑动验证功能,默认不需要滑动验证,值为false

//   isCA: false,                                                  //是否开启CA登陆

//   isRelateDingTalk: false,                                      //是否有与钉钉相关的业务

//   dingTalkAgentId: "325262018",                                 //代理id,与钉钉同步的接口

//   syncToUserResource: true,                                     //在文件上传组件中出现 ‘同步至数字资源’ 按钮

//   singleTab: false,                                             //是否单页签交互，默认为false（即多tab页签交互）

//   singleMenu: false,                                            //头部是否用所有门户替换一级菜单

//   openDefaultMenu: true,                                        //是否打开第1个菜单：默认为false

//   enbaleCustomLayout: false,

//   hideSingleTab: "",

//   tabNumber: 10,                                                //tab标签页最多显示数量

//   defaultLanguage: null,                                     //国际化默认语言版本,zh-CN表示中文；en-US表示英文; 为空字符串或为null表示没有国际化功能，不能切换语言

//   projectName: "智慧博物馆统一登录平台",                         //系统名称，打包编译后中文会进行Unicode编码

//   customerName: "智慧博物馆",                                   //客户名称，打包编译后中文会进行Unicode编码
//   defaultDashboard: "/oa/dashboard",                              //默认工作台
//   defaultPortal: "/oa/dashboard",                               //工作门户
//   fullScreen: "/oa/portal,/fam/aps/ProjectDisplay,/fam/ags/GisMap,/oa/dashboard",

//   enableSsoLogin: false,                                         //启用ssoLogin登录

//   resourceMark: true,                                        //数字资源是否有图像标注功能

//   multiOrgWaterMark: false,

//   projectLogo: "/assets/Theme/default/img/logo.png",           //头部左侧背景图，当projectLogo为空时，显示projectName

//   projectLogoWidth: "220",                                     //当projectLogo不为空时，图片的宽度(该宽度严格为图片的宽度，高度默认值26px)

//   loginStyle: 1,                                                //登录页风格：默认为1,表示竖版；2,表示横版

//   loginBackGround: "/assets/Theme/default/img/login-bg.jpg",   //登录页背景图

//   favoriteIco: "/favicon.ico",                                 //系统ico图标

//   isLoadAllMenu: true,                                          //是否按模块加载所有子级菜单，默认为false

//   ssoTokenName: "Zxy",                                          //SSo登录配置的token名，根据约定动态更改

//   coptyRight: "版权所有 © 2019-2025 &nbsp;数文科技 &nbsp; 建议浏览器：chrome/360极速浏览器"  //版权相关声明
//   //#endregion

// };




// // 测试环境
// export const environment = {
//   production: !0, seekerWebAPI: "http://192.168.10.13:8260/sw-basic/",
//   fileWebAPI: "http://192.168.10.13:8260/sw-file/",
//   activitiWebAPI: "http://192.168.10.13:8260/sw-activiti/",
//   scheduleWebApi: "http://192.168.10.13:8260/sw-scheduler/",
//   ruleWebApi: "http://192.168.10.13:8260/sw-rule/",
//   webSoketApi: "ws://192.168.10.13:8260:8041/",
//   outWebAPI: "http://192.168.10.13:8260:8074/",
//   smsWebAPI: "http://192.168.10.13:8260:8021/",
//   esWebAPI: "http://192.168.10.13:8260/sw-es/",
//   saasWebAPI: "http://192.168.10.13:8260/sw-saas/",
//   staticFileUrl: "http://192.168.10.13:8109/",
//   onlineOfficeWebAPI: "http://192.168.10.210:9999/",
//   iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",
//   uploadDirectory: "7588b9f22b0c11eba02c7020840bjwys",
//   sendCodeUrl: "http://192.168.10.89:8021/",
//   //#endregion
//   //#region 智慧博物馆业务产品领域微服务api地址配置区域
//   cmsWebAPI: "http://192.168.10.13:8260/sw-cms/",
//   damWebAPI: "http://192.168.10.13:8260/sw-dam/",
//   trmWebAPI: "http://192.168.10.13:8260/sw-trm/",
//   actWebAPI: "http://192.168.10.13:8260/sw-act/",
//   volWebAPI: "http://192.168.10.13:8260/sw-vve/",
//   vipWebAPI: "http://192.168.10.13:8260/sw-vve/",
//   expWebAPI: "http://192.168.10.13:8260/sw-vve/",
//   wecWebAPI: 'http://192.168.10.13:8260/sw-cms/',
//   apfWebAPI: "http://192.168.10.13:8260/sw-apf-beijingerqi/",
//   ckfWebAPI: "http://192.168.10.13:8260/sw-ckf-beijingerqi/",
//   drmWebAPI: "http://192.168.10.13:8260/sw-drm-beijingerqi/",
//   amsWebAPI: "http://192.168.10.13:8260/sw-oms-beijingerqi/",
//   dssWebAPI: "http://192.168.10.13:8260/sw-dss-beijingerqi/",
//   dpsWebAPI: "http://192.168.10.13:8260/sw-dps-beijingerqi/",
//   //#endregion
//   //#region  其他业务产品领域微服务api地址配置区域
//   pcrWebAPI: "http://192.168.10.13:8260/sw-pcr-zy-beijingerqi/",
//   cirWebAPI: "",
//   apmWebAPI: "http://192.168.10.13:8260/sw-apm-bj/",
//   famWebAPI: "http://192.168.10.13:8260/sw-fam-bj/",
//   sicWebAPI: "http://192.168.10.13:8260/sw-sic-beijingerqi/",
//   famPanoPrefix: "http://192.168.10.13:8342/",
//   caAPI: "http://192.168.10.75:11001/",
//   caWebsocketApi: "ws://192.168.10.75:11001/",
//   apoWebAPI: "",
//   proWebAPI: "",
//   webSocketPcrUrl: "",
//   kgsWebAPI: "http://192.168.10.97:8095/",
//   mapWebAPI: "",
//   rmsWebAPI: "http://192.168.10.66:9990/sw-rms-beijingerqi",
//   sesWebAPI: "http://192.168.10.66:9990/sw-ses-beijingerqi",
//   qasWebAPI: "http://192.168.10.66:9990/sw-qas-beijingerqi",
//   omsWebAPI: "http://192.168.10.13:8260/sw-oms-beijingerqi/",
//   anbWebAPI: "http://192.168.10.13:8260/sw-anb-beijingerqi/",
//   aamWebAPI: "http://192.168.10.13:8260/sw-aam-beijingerqi/",
//   rdpWebAPI: "http://192.168.10.13:8260/sw-rdp-beijingerqi/",
//   guidVideoFilePath: "7588b9f22b0c11eba02c7020840bjwys/operateVideo/",   //指引视频地址
//   dataDashboardUrl: "http://192.168.10.13:8324/",               //数据大屏地址
//   encryptedPassword: !1, multiTenancy: !1, systemCode: "WYS_BEIJING", isVcode: !1, isSliderCode: !1, isCA: !1, isRelateDingTalk: !1, dingTalkAgentId: "325262018", syncToUserResource: !0, singleTab: !1, singleMenu: !1, openDefaultMenu: !0, tabNumber: 10, enbaleCustomLayout: !1, hideSingleTab: "", defaultLanguage: null, projectName: "\u667a\u6167\u535a\u7269\u9986\u7edf\u4e00\u767b\u5f55\u5e73\u53f0", customerName: "\u667a\u6167\u535a\u7269\u9986", defaultDashboard: "/oa/dashboard", defaultPortal: "/oa/dashboard", fullScreen: "/oa/portal,/fam/aps/ProjectDisplay,/fam/ags/GisMap,/oa/dashboard", enableSsoLogin: !1, resourceMark: !0, multiOrgWaterMark: !1, projectLogo: "/assets/Theme/default/img/logo.png", projectLogoWidth: "220", loginStyle: 1, loginBackGround: "/assets/Theme/default/img/login-bg.jpg", favoriteIco: "/favicon.ico", isLoadAllMenu: !0, ssoTokenName: "Zxy",
//   coptyRight: "版权所有 © 2019-2025 &nbsp;数文科技 &nbsp; 建议浏览器：chrome/360极速浏览器"  //版权相关声明
//   //#endregion

// };






// 正式环境
// export const environment = {
//    production: !0,
//  seekerWebAPI: "https://www.bjkaogu.cn/g/sw-basic/",
//     fileWebAPI: "https://www.bjkaogu.cn/g/sw-file/",
//     activitiWebAPI: "https://www.bjkaogu.cn/g/sw-activiti/",
//     scheduleWebApi: "https://www.bjkaogu.cn/g/sw-scheduler/",
//     ruleWebApi: "https://www.bjkaogu.cn/g/sw-rule/",
//     webSoketApi: "ws://192.168.10.96:8000:8041/",
//     outWebAPI: "http://192.168.10.96:8000:8074/",
//     smsWebAPI: "http://192.168.10.96:8000:8021/",
//     esWebAPI: "https://www.bjkaogu.cn/g/sw-es/",
//     saasWebAPI: "https://www.bjkaogu.cn/g/sw-saas/",
//     staticFileUrl: "https://www.bjkaogu.cn/fileUpload/",
//     onlineOfficeWebAPI: "https://www.bjkaogu.cn/fileUpload/",
//     iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",
//     uploadDirectory: "",
//     sendCodeUrl: "http://192.141.6.105:8021/",
//     //#endregion
//     //#region 智慧博物馆业务产品领域微服务api地址配置区域
//     cmsWebAPI: "https://www.bjkaogu.cn/g/sw-cms/",
//     damWebAPI: "https://www.bjkaogu.cn/g/sw-dam/",
//     trmWebAPI: "https://www.bjkaogu.cn/g/sw-trm/",
//     actWebAPI: "https://www.bjkaogu.cn/g/sw-act/",
//     volWebAPI: "https://www.bjkaogu.cn/g/sw-vve/",
//     vipWebAPI: "https://www.bjkaogu.cn/g/sw-vve/",
//     expWebAPI: "https://www.bjkaogu.cn/g/sw-vve/",
//     wecWebAPI: 'https://www.bjkaogu.cn/g/sw-cms/',
//     apfWebAPI: "https://www.bjkaogu.cn/g/sw-apf/",
//     ckfWebAPI: "https://www.bjkaogu.cn/g/sw-ckf/",
//     drmWebAPI: "https://www.bjkaogu.cn/g/sw-drm/",
//     amsWebAPI: "https://www.bjkaogu.cn/g/sw-oms/",
//     dssWebAPI: "https://www.bjkaogu.cn/g/sw-dss/",
//     dpsWebAPI: "https://www.bjkaogu.cn/g/sw-dps/",
//     //#endregion
//     //#region  其他业务产品领域微服务api地址配置区域
//     pcrWebAPI: "https://www.bjkaogu.cn/g/sw-pcr-zy/",
//     cirWebAPI: "",
//     apmWebAPI: "https://www.bjkaogu.cn/g/sw-apm-beijing/",
//     famWebAPI: "https://www.bjkaogu.cn/g/sw-fam-beijing/",
//     famPanoPrefix: "https://www.bjkaogu.cn/",
//     caAPI: "http://192.141.6.105:11001/",
//     caWebsocketApi: "ws://192.141.6.105:11001/",
//     apoWebAPI: "",
//     proWebAPI: "",
//     webSocketPcrUrl: "",
//     kgsWebAPI: "http://192.168.10.97:8095/",
//     mapWebAPI: "",
//     rmsWebAPI: "https://www.bjkaogu.cn/g/sw-rms",
//     sesWebAPI: "https://www.bjkaogu.cn/g/sw-ses",
//     qasWebAPI: "https://www.bjkaogu.cn/g/sw-qas",
//     omsWebAPI: "https://www.bjkaogu.cn/g/sw-oms/",
//     anbWebAPI: "https://www.bjkaogu.cn/g/sw-anb/",
//     aamWebAPI: 'https://www.bjkaogu.cn/g/sw-aam/',
//     sicWebAPI: "https://www.bjkaogu.cn/g/sw-sic/",
//     rdpWebAPI: "https://www.bjkaogu.cn/g/sw-rdp/",
//     guidVideoFilePath: "7588b9f22b0c11eba02c7020840bjwys/operateVideo/",   //指引视频地址
//     //#endregion
//     //#region 项目基本属性配置区域
//     dataDashboardUrl: "https://www.bjkaogu.cn/",
//   //数据大屏地址
//   encryptedPassword: !1, multiTenancy: !1, systemCode: "WYS_BEIJING", isVcode: !0, isSliderCode: !0, isCA: !1, isRelateDingTalk: !1, dingTalkAgentId: "4173676689", syncToUserResource: !0, singleTab: !1, singleMenu: !1, openDefaultMenu: !0, tabNumber: 10, enbaleCustomLayout: !1, hideSingleTab: "", defaultLanguage: null, projectName: "\u667a\u6167\u535a\u7269\u9986\u7edf\u4e00\u767b\u5f55\u5e73\u53f0", customerName: "\u667a\u6167\u535a\u7269\u9986", defaultDashboard: "/oa/dashboard", defaultPortal: "/oa/dashboard", fullScreen: "/oa/portal,/fam/aps/ProjectDisplay,/fam/ags/GisMap,/oa/dashboard", enableSsoLogin: !1, resourceMark: !0, multiOrgWaterMark: !1, projectLogo: "/assets/Theme/default/img/logo.png", projectLogoWidth: "220", loginStyle: 1, loginBackGround: "/assets/Theme/default/img/login-bg.jpg", favoriteIco: "/favicon.ico", isLoadAllMenu: !0, ssoTokenName: "Zxy",
//   coptyRight: "版权所有 © 2019-2025 &nbsp;数文科技 &nbsp; 建议浏览器：chrome/360极速浏览器"  //版权相关声明
//   //#endregion
// };

// 演示服
export const environment =  {
    production: !0,
    seekerWebAPI: "https://bjtest.cncis.com.cn/g/sw-basic/",
    fileWebAPI: "https://bjtest.cncis.com.cn/g/sw-file/",
    activitiWebAPI: "https://bjtest.cncis.com.cn/g/sw-activiti/",
    scheduleWebApi: "https://bjtest.cncis.com.cn/g/sw-scheduler/",
    ruleWebApi: "https://bjtest.cncis.com.cn/g/sw-rule/",
    webSoketApi: "ws://192.168.10.96:8000:8041/",
    outWebAPI: "http://192.168.10.96:8000:8074/",
    smsWebAPI: "http://192.168.10.96:8000:8021/",
    esWebAPI: "https://bjtest.cncis.com.cn/g/sw-es/",
    saasWebAPI: "https://bjtest.cncis.com.cn/g/sw-saas/",
    staticFileUrl: "https://bjtest.cncis.com.cn/fileUpload/",
    onlineOfficeWebAPI: "https://bjtest.cncis.com.cn/fileUpload/",
    iiifImgUrl: "http://192.168.10.210:8183/iiif/2/DRM_USER_RESOURCE%2F",
    uploadDirectory: "",
    sendCodeUrl: "http://192.141.6.105:8021/",
    //#endregion
    //#region 智慧博物馆业务产品领域微服务api地址配置区域
    cmsWebAPI: "https://bjtest.cncis.com.cn/g/sw-cms/",
    damWebAPI: "https://bjtest.cncis.com.cn/g/sw-dam/",
    trmWebAPI: "https://bjtest.cncis.com.cn/g/sw-trm/",
    actWebAPI: "https://bjtest.cncis.com.cn/g/sw-act/",
    volWebAPI: "https://bjtest.cncis.com.cn/g/sw-vve/",
    vipWebAPI: "https://bjtest.cncis.com.cn/g/sw-vve/",
    expWebAPI: "https://bjtest.cncis.com.cn/g/sw-vve/",
    wecWebAPI: 'https://bjtest.cncis.com.cn/g/sw-cms/',
    apfWebAPI: "https://bjtest.cncis.com.cn/g/sw-apf/",
    ckfWebAPI: "https://bjtest.cncis.com.cn/g/sw-ckf/",
    drmWebAPI: "https://bjtest.cncis.com.cn/g/sw-drm/",
    amsWebAPI: "https://bjtest.cncis.com.cn/g/sw-oms/",
    dssWebAPI: "https://bjtest.cncis.com.cn/g/sw-dss/",
    dpsWebAPI: "https://bjtest.cncis.com.cn/g/sw-dps/",
    //#endregion
    //#region  其他业务产品领域微服务api地址配置区域
    pcrWebAPI: "https://bjtest.cncis.com.cn/g/sw-pcr-zy/",
    cirWebAPI: "",
    apmWebAPI: "https://bjtest.cncis.com.cn/g/sw-apm-beijing/",
    famWebAPI: "https://bjtest.cncis.com.cn/g/sw-fam-beijing/",
    famPanoPrefix: "https://bjtest.cncis.com.cn/",
    caAPI: "http://192.141.6.105:11001/",
    caWebsocketApi: "ws://192.141.6.105:11001/",
    apoWebAPI: "",
    proWebAPI: "",
    webSocketPcrUrl: "",
    kgsWebAPI: "http://192.168.10.97:8095/",
    mapWebAPI: "",
    rmsWebAPI: "https://bjtest.cncis.com.cn/g/sw-rms",
    sesWebAPI: "https://bjtest.cncis.com.cn/g/sw-ses",
    qasWebAPI: "https://bjtest.cncis.com.cn/g/sw-qas",
    omsWebAPI: "https://bjtest.cncis.com.cn/g/sw-oms/",
    anbWebAPI: "https://bjtest.cncis.com.cn/g/sw-anb/",
    aamWebAPI: 'https://bjtest.cncis.com.cn/g/sw-aam/',
    sicWebAPI: "https://bjtest.cncis.com.cn/g/sw-sic/",
    rdpWebAPI: "https://bjtest.cncis.com.cn/g/sw-rdp/",
    guidVideoFilePath: "7588b9f22b0c11eba02c7020840bjwys/operateVideo/",   //指引视频地址
    //#endregion
    //#region 项目基本属性配置区域
    dataDashboardUrl: "https://bjtest.cncis.com.cn/",
    //数据大屏地址
    encryptedPassword: !1, multiTenancy: !1, systemCode: "WYS_BEIJING", isVcode: !0, isSliderCode: !0, isCA: !1, isRelateDingTalk: !1, dingTalkAgentId: "4185167800", syncToUserResource: !0, singleTab: !1, singleMenu: !1, openDefaultMenu: !0, tabNumber: 10, enbaleCustomLayout: !1, hideSingleTab: "", defaultLanguage: null, projectName: "\u667a\u6167\u535a\u7269\u9986\u7edf\u4e00\u767b\u5f55\u5e73\u53f0", customerName: "\u667a\u6167\u535a\u7269\u9986", defaultDashboard: "/oa/dashboard", defaultPortal: "/oa/dashboard", fullScreen: "/oa/portal,/fam/aps/ProjectDisplay,/fam/ags/GisMap,/oa/dashboard", enableSsoLogin: !1, resourceMark: !0, multiOrgWaterMark: !1, projectLogo: "/assets/Theme/default/img/logo.png", projectLogoWidth: "220", loginStyle: 1, loginBackGround: "/assets/Theme/default/img/login-bg.jpg", favoriteIco: "/favicon.ico", isLoadAllMenu: !0, ssoTokenName: "Zxy",
    coptyRight: "版权所有 © 2019-2025 &nbsp;数文科技 &nbsp; 建议浏览器：chrome/360极速浏览器" //版权相关声明
    //#endregion
};